import { useUnreads } from "@talkjs/react";

/**
 * Gets the total unread message count from TalkJS.
 *
 * @example
 * ```typescript
 * const unreadCount = useChatUnreadCount();
 * ```
 */
export function useChatUnreadCount(): number {
  const unreads = useUnreads();

  return (
    unreads?.reduce((sum, item) => sum + (item.unreadMessageCount || 0), 0) || 0
  );
}

export default useChatUnreadCount;

